export default [
  { title: 'Technical', routeName: 'settings-technical' },

  { title: 'Email', routeName: 'settings-email' },

  { title: 'Notifications', routeName: 'settings-notifications' },

  { title: 'Limits', routeName: 'settings-limits' },

  { title: 'Watermark', routeName: 'settings-watermark' },

];
